module.exports = __webpack_public_path__ + "static/img/logo100.37e0a57.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo100.png
// module id = 2Nj3
// module chunks = 1